/// <summary>
/// dashboard visual for a simple signal 
/// Author: AFU<br />
/// Date: 13.8.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 -  13.8.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardStacked", jQuery.common.vcBaseV4, {

    myStatus: { StackedType: 0}, //0 = in percent, 1 = absolute values

    _create: function () {
        this._createVisual(417);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-data");

            //set chart type from parameters
            me.myStatus.StackedType = me.options.parameter.Extended.StackedType;
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _isRenderTargetAvailable: function () {
        var me = this;
        return !!(me.myHtml && me.myHtml.chart && me.myHtml.chart.length && $.contains(document, me.myHtml.chart[0]));
    },

    _handleChartError: function (context, error, details) {
        var me = this;
        var message = "DashboardStacked " + context + " failed";
        if (error && error.message) message += ": " + error.message;

        if (window.console && console.error) {
            console.error(message, {
                error: error,
                stack: error && error.stack ? error.stack : null,
                details: details || null,
                vcgid: me.options && me.options.invoke ? me.options.invoke.vcgid : null
            });
        }

        me._writeErr(error || new Error(message));
    },
   
    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        var me = this;
        try {
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "dashboard-stacked").css({ "width": "100%", "height": "100%", "overflow": "hidden" });
            me.myHtml.chart = $("<div>").addClass("dashboard-stacked-chart").css({ "width": "100%", "height": "100%" });
            me.myHtml.wrapper.append(me.myHtml.chart);
            me.myRoot.html(me.myHtml.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    //_formatNumber: function (raw) {
    //        if(raw === null || raw === undefined) return "--";
    //        if (!raw && raw !== 0) return "--";
    //        var parts = raw.toString().split(".");
    //        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    //        return parts.length > 1 ? parts[0] + "," + parts[1] : parts[0];
    //    } ,
   

    _fetch: function () {
        var me = this;
        try {




            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, SumValues:true }, function (result) {
                if (result === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                if (!me._isRenderTargetAvailable()) {
                    if (window.console && console.warn) {
                        console.warn("DashboardStacked render skipped: target container is no longer in DOM.", {
                            vcgid: me.options && me.options.invoke ? me.options.invoke.vcgid : null
                        });
                    }
                    return false;
                }
                me._loadChart(result);
            });

        } catch (e) { me._handleChartError("_fetch", e); return false; }
        return true;
    },

    _loadChart: function (result) {
        var me = this;
        try {




            if (!result || !result.Entries || !result.Entries.length) {
                me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false);
                me._handleChartError("_loadChart", new Error("Result does not contain chart entries."), { result: result });
                return false;
            }

            if (!me._isRenderTargetAvailable()) {
                me._handleChartError("_loadChart", new Error("Rendering div not found (chart container is detached)."));
                return false;
            }

            var useAbsolute = me.myStatus.StackedType == 1;
            var absoluteUnit = "";
            var formatAbsoluteValue = function (value) {
                if (value === null || value === undefined || isNaN(value)) return "--";
                return Highcharts.numberFormat(Number(value), 2, ",", ".");
            };
            var categories = [];
            var seriesMap = {};

            $.each(result.Entries, function (i, s) {
                var ts = s.Timestamp ? String(s.Timestamp) : ("Kategorie " + (i + 1));
                if ($.inArray(ts, categories) === -1) categories.push(ts);
                if (!seriesMap[s.NameSimple]) seriesMap[s.NameSimple] = {};
                seriesMap[s.NameSimple][ts] = (seriesMap[s.NameSimple][ts] || 0) + s.Value;
                if (!absoluteUnit && s.Unit) absoluteUnit = s.Unit;
            });

            var absoluteUnitSuffix = absoluteUnit ? " " + absoluteUnit : "";
         
            var seriesList = [];
            $.each(seriesMap, function (name, catValues) {
                var data = [];
                $.each(categories, function (ci, cat) {
                    data.push(catValues[cat] || 0);
                });
                seriesList.push({ name: name, data: data });
            });

            var options = {
                chart: { type: "column" },
                title: { text: null },
                xAxis: { categories: categories, labels: { enabled: true, rotation: 0, style: { fontSize: "11px" } }, lineColor: "#555555", lineWidth: 1, tickColor: "#555555", tickWidth: 1, title: { text: null } },
                yAxis: {
                    min: 0,
                    title: { text: null },
                    labels: useAbsolute
                        ? {
                            formatter: function () {
                                return formatAbsoluteValue(this.value) + absoluteUnitSuffix;
                            }
                        }
                        : { format: "{value}%" },
                    lineColor: "#555555",
                    lineWidth: 1,
                    tickColor: "#555555",
                    tickWidth: 1
                },
                legend: { useHTML: true, labelFormatter: function () { var text = $('<div>').html(this.name).text(); return '<span title="' + text.replace(/"/g, '&quot;') + '">' + this.name + '</span>'; } },
                tooltip: useAbsolute
                    ? {
                        useHTML: true,
                        formatter: function () {
                            return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + formatAbsoluteValue(this.y) + absoluteUnitSuffix + '</b><br/>';
                        }
                    }
                    : {
                        useHTML: true,
                        pointFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}: <b>{point.percentage:.1f}%</b><br/>"
                    },
                plotOptions: {
                    column: {
                        stacking: useAbsolute ? "normal" : "percent",
                        dataLabels: useAbsolute
                            ? {
                                enabled: true,
                                formatter: function () {
                                    return formatAbsoluteValue(this.y) + absoluteUnitSuffix;
                                }
                            }
                            : { enabled: true, format: "{point.percentage:.0f}%" }
                    }
                },
                series: seriesList
            };

            if (!me.myHtml.chart || !me.myHtml.chart.length || !me.myHtml.chart[0]) {
                me._handleChartError("_loadChart", new Error("Rendering div not found (chart element missing)."));
                return false;
            }

            var ro = new RampOptions();
            if (me.myChart && me.myChart.destroy) me.myChart.destroy();
            me.myChart = Highcharts.chart(me.myHtml.chart[0], $.extend({}, ro.getTheme(), options));

        } catch (e) {
            me._handleChartError("_loadChart", e, {
                hasRenderTarget: me._isRenderTargetAvailable(),
                entriesCount: result && result.Entries ? result.Entries.length : 0
            });
            return false;
        }
        return true;
    },



    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});